import React, {} from 'react';
import AssignmentsList from './AssignmentsList';

const AssignmentsReport = () => {
    return (
        <>
            <AssignmentsList />
        </>
    );
}
export default AssignmentsReport;